import {
	ContextService,
	GamedayApiService
} from "@prestosports/prestostats-core/Services";
import {
	INIT_TEAM_CONTEXT,
	INIT_TEAMS_CONTEXT_COMPLETE,
	REFRESH_TEAM_CONTEXT,
	REFRESH_TEAM_CONTEXT_COMPLETE,
	SAVE_TEAM_CONTEXT,
	SAVE_TEAM_CONTEXT_COMPLETE
} from "./constants";
import GamedayApiClient from "../../services/gameday-api-client";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

export const initTeamsContext = async (game, teams, dispatch) => {
	dispatch({
		type: INIT_TEAM_CONTEXT
	});

	const { homeTeam, awayTeam } = teams;
	const gameContext = await ContextService.getGameContext(game.id);
	const homeTeamContext = gameContext.getTeamContext(homeTeam.id);
	const awayTeamContext = gameContext.getTeamContext(awayTeam.id);

	dispatch({
		type: INIT_TEAMS_CONTEXT_COMPLETE,
		payload: {
			homeTeamContext: homeTeamContext && homeTeamContext.toJSON(),
			awayTeamContext: awayTeamContext && awayTeamContext.toJSON()
		}
	});
};

export const saveTeamContext = async (game, teamContext, dispatch) => {
	dispatch({
		type: SAVE_TEAM_CONTEXT
	});

	const gameContext = await ContextService.getGameContext(game.id);
	Object.assign(gameContext.getTeamContext(teamContext.teamId), teamContext);

	const savedGameContext = await ContextService.updateContext(gameContext);
	const savedTeamContext = savedGameContext.getTeamContext(teamContext.teamId);

	dispatch({
		type: SAVE_TEAM_CONTEXT_COMPLETE,
		payload: { teamContext: savedTeamContext && savedTeamContext.toJSON() }
	});
};

export const refreshTeamsContext = async (gameId, dispatch) => {
	dispatch({
		type: REFRESH_TEAM_CONTEXT
	});

	const gameContext = await ContextService.getGameContext(gameId);
	const { awayTeamId, homeTeamId } = gameContext;
	const homeTeamContext = gameContext.getTeamContext(homeTeamId);
	const awayTeamContext = gameContext.getTeamContext(awayTeamId);

	dispatch({
		type: REFRESH_TEAM_CONTEXT_COMPLETE,
		payload: {
			homeTeamContext: homeTeamContext && homeTeamContext.toJSON(),
			awayTeamContext: awayTeamContext && awayTeamContext.toJSON()
		}
	});
};
